/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index info-card to autogenerate all the components and extensions
 * Used by "prepareInfoCards"
 */

import InfoCard from './info-card/InfoCard'
export * from './info-card/InfoCard'
export default InfoCard
